import React, { useId } from 'react';

// SVG zászlók — a Windows böngészők nem jelenítik meg a zászló emojikat,
// ezért beágyazott SVG-t használunk, ami minden platformon azonos.

// Vízszintes vagy függőleges háromsávos zászló
const Stripes = ({ colors, vertical = false, heights }) => {
  const n = colors.length;
  const sizes = heights || Array(n).fill(1);
  const total = sizes.reduce((a, b) => a + b, 0);
  let offset = 0;
  return (
    <>
      {colors.map((c, i) => {
        const frac = sizes[i] / total;
        const rect = vertical
          ? <rect key={i} x={offset * 60} y="0" width={frac * 60} height="40" fill={c} />
          : <rect key={i} x="0" y={offset * 40} width="60" height={frac * 40} fill={c} />;
        offset += frac;
        return rect;
      })}
    </>
  );
};

const UnionJack = ({ uid }) => (
  <>
    <clipPath id={`uj-t-${uid}`}>
      <path d="M30,20 h30 v20 z v20 h-30 z h-30 v-20 z v-20 h30 z" />
    </clipPath>
    <rect width="60" height="40" fill="#012169" />
    <path d="M0,0 L60,40 M60,0 L0,40" stroke="#fff" strokeWidth="8" />
    <path d="M0,0 L60,40 M60,0 L0,40" clipPath={`url(#uj-t-${uid})`} stroke="#C8102E" strokeWidth="5" />
    <path d="M30,0 v40 M0,20 h60" stroke="#fff" strokeWidth="13" />
    <path d="M30,0 v40 M0,20 h60" stroke="#C8102E" strokeWidth="8" />
  </>
);

const FLAGS = {
  en: (uid) => <UnionJack uid={uid} />,
  es: () => <Stripes colors={['#AA151B', '#F1BF00', '#AA151B']} heights={[1, 2, 1]} />,
  de: () => <Stripes colors={['#000000', '#DD0000', '#FFCE00']} />,
  fr: () => <Stripes colors={['#0055A4', '#FFFFFF', '#EF4135']} vertical />,
  nl: () => <Stripes colors={['#AE1C28', '#FFFFFF', '#21468B']} />,
  pl: () => <Stripes colors={['#FFFFFF', '#DC143C']} />,
  hu: () => <Stripes colors={['#CD2A3E', '#FFFFFF', '#436F4D']} />,
};

const Flag = ({ code, className = '' }) => {
  const uid = useId();
  const render = FLAGS[code];
  if (!render) return null;
  return (
    <svg
      className={`flag-svg ${className}`}
      viewBox="0 0 60 40"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label={code}
    >
      {render(uid)}
    </svg>
  );
};

export default Flag;
